import { FC, memo } from 'react'
import { Text, Flex, IconButton } from '@chakra-ui/react'

import { ArrowLeft } from 'components/icons'

type Props = {
  year: number
  stringMonth: string
  onClick: () => void
}

const StartCalendarHeader: FC<Props> = ({ year, stringMonth, onClick }) => {
  return (
    <Flex justify="space-between" align="center">
      <IconButton
        size="xs"
        variant="ghost"
        rounded="full"
        aria-label="Ir para o mês anterior"
        icon={<ArrowLeft />}
        onClick={onClick}
        _hover={{ bg: 'primary', color: 'light' }}
      />

      <Text color="primary" fontSize="md" marginRight="50px">
        {stringMonth} de {year}
      </Text>
    </Flex>
  )
}

export default memo(StartCalendarHeader)
